import React, { CSSProperties, FunctionComponent } from 'react';

import { InlineImage } from '@gojob/cms';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { GatsbyImage } from 'gatsby-plugin-image';

interface ImageProps {
  image: InlineImage;
  className?: string;
  style?: CSSProperties;
}

const useStyles = () => {
  const { breakpoint } = useTheme();

  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
    },
    image: {
      flex: '1 1 100%',
      [breakpoint.up('md')]: {
        flex: '1 1 65%',
      },
    },
  } as const;
};

const Image: FunctionComponent<ImageProps> = (props) => {
  const { image, className, style } = props;
  const classes = useStyles();

  return (
    <div css={classes.root} className={className} style={style}>
      <GatsbyImage
        css={classes.image}
        loading="lazy"
        image={image?.asset.localFile.childImageSharp?.gatsbyImageData}
        alt={image?.alt}
      />
    </div>
  );
};

export default Image;
